import { HttpClient } from '@angular/common/http';
import { Injectable } from  '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class RoyaltiesService {

    constructor(private readonly _http: HttpClient){}

    // CONFIGURADOR ROYALTIES
    public getRoyalties(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Royalty/GetAllConFiltro', filters);
    }
  
    public getRoyalty(royaltyId){
        return this._http.get<any>(environment.apiEndpoint + '/Royalty/GetById?royaltyId=' + royaltyId);
    }
  
    public createRoyalty(royalty) {
        return this._http.post<any>(environment.apiEndpoint + '/Royalty', royalty);
    }
  
    public createRoyaltyMultiple(royalty) {
          return this._http.post<any>(environment.apiEndpoint + '/Royalty/InsertRoyaltyMultiple', royalty);
    }
  
    public updateRoyalty(royalty) {
        return this._http.put<any>(environment.apiEndpoint + '/Royalty', royalty);
    }
  
    public deleteRoyalty(royaltyId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Royalty/?id=' + royaltyId);
    }
  
    public getEntidadControlAll() {
        return this._http.get<any>(environment.apiEndpoint + '/EntidadControl/GetAll');
    }
  
    public getPaisesByEntidadControl(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }
  
    public getDenominacionesByPaisEntidadControl(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }
  
    public getMarcasByPaisEntidadControlDeno(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    // GESTION DE ROYALTIES
    public getRoyaltiesFee(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Royalty/CalculaFee', filters);
    }
  
    public getEtiquetadoresByEntidadControl(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllConFiltro', filters);
    }
  
    public getProuctoresByEntidadControl(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Productor/GetAllConFiltro', filters);
    }
  
    public getReportRoyalty(filters){
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepRoyalty', filters);
    }
  
    // AYUDA
    public getDocHelp(nombreArchivo: string) {
        return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }
}